<template>
  <div :class="[`quote__info quote__info_${productType}`]" @click="$emit('click')">
    <div class="quote__info-title quote__info-title_claims">
      <div class="quote__info-left">
        <svg><use :xlink:href="titleImg"></use></svg>
          {{ productTitle }}
      </div>
      <span v-if="endPolicyDate">
        <i class="quote__info-until" :class="{'quote__info-until_error': untilError}">
          {{ $t('qic_until') }} {{formattedEndPolicyDate}}
        </i>
      </span>
    </div>
    <ul class="quote__info-list quote__info-list_top">
      <li>{{ productName }}</li>
      <li>{{ $t('qic_policy_number') }}:
        <QuoteCopyButton :quote-text="policyNumber" />
      </li>
    </ul>
    <ul class="quote__info-list quote__info-list_bottom" v-if="!disableInfoList">
      <slot name="info"></slot>
    </ul>
  </div>
</template>

<script>
import { formatDate } from '../../utils/formatDate'
import QuoteCopyButton from './QuoteCopyButton.vue'
export default {
  name: 'RenewInformation',
  components: {
    QuoteCopyButton
  },
  props: {
    productName: { type: String, default: 'Quote product name was not set' },
    productType: { type: String, default: 'car' },
    productTitle: { type: String, default: 'Product title was not set' },
    policyNumber: { type: [String, Number], default: 'Policy number was not set' },
    endPolicyDate: {},
    disableInfoList: { type: Boolean, default: false }
  },
  computed: {
    formattedEndPolicyDate () {
      if (this.endPolicyDate?.getDate) {
        return formatDate(this.endPolicyDate, this.$i18n.locale)
      }
      if (!this.startPolicyDate?.getDate) return 'No date'
      const duration = this.policyDayDuration || 0
      const date = new Date(this.startPolicyDate.getFullYear(), this.startPolicyDate.getMonth(), this.startPolicyDate.getDate() + duration)
      return formatDate(date, this.$i18n.locale)
    },
    untilError () {
      const now = new Date()
      const untilDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 30)
      if (!this.endPolicyDate?.getDate) return false
      return untilDate - this.endPolicyDate > 0
    },
    titleImg () {
      return require('../../assets/images/quote/info-sprite.svg') + '#' + this.productType
    }
  }
}
</script>
